export default __webpack_public_path__ + "static/moon-xs-d2bbc07fd2bc9ba20be738acd2189469.png";